import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "w-full es-institute-form-div" }
const _hoisted_6 = { class: "row w-full" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "w-full justify-center item-center font-bold-600" }
const _hoisted_9 = { class: "w-full justify-center item-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "w-full justify-center item-center" }

import { watch, ref } from 'vue';
import { AdminApi, ApiError, LinkInstitutePersonRequest, MedicalPersonLightResponse, PersonInstituteLightResponse } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { FilterMatchMode } from '@primevue/core/api';
import SharedService from '@/services/SharedService';
import Tag from 'primevue/tag';
import EsAddInstitutePersonForm from '@/components/form/admin/esAddInstitutePersonForm.vue';
import { SctLanguageItem } from "@/models/share.model";
import EsConfirmDialog from '@/components/modals/esConfirmDialog.vue';
import EsButtonIcon from '@/components/esButtonIcon.vue';

type PersonInstituteLightResponseWithId = PersonInstituteLightResponse & { id: string | undefined };


export default /*@__PURE__*/_defineComponent({
  __name: 'esManageInstitute',
  props: {
    isOpen: { type: Boolean },
    currentMedicalPerson: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const adminApi = new AdminApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();

const emits = __emit;

const medicalPersonInstitutesList = ref<PersonInstituteLightResponse[]>([]);
const editInstitute = ref<PersonInstituteLightResponseWithId>(undefined)
const editAdminInstitute = ref<boolean>(undefined);

const isDeleteModalOpen = ref<boolean>(false);

const currentInstituteToDelete = ref<LinkInstitutePersonRequest>({
    instituteId: undefined,
    addRoleAdmin: undefined
});

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const loading = ref(true);

const getMedicalPersonIntituteData = () => {
  if (props.currentMedicalPerson && props.currentMedicalPerson.id) {
    adminApi.getInstituteByMedicalPerson({personId: props.currentMedicalPerson.id}).then((res: PersonInstituteLightResponse[]) => {
      medicalPersonInstitutesList.value = res.sort((a, b) =>
        a.instituteLight.name.localeCompare(b.instituteLight.name, SctLanguageItem.FrFr, { sensitivity: 'base' })
      );
      loading.value = false;
    }).catch((error: ApiError) => {
        if (error.status) {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t(`error.${error.status}`)
            });
        } else {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('error.DEFAULT')
            });
        }
    });
  }
}

const getCurrentInstituteToEdit = (institut : PersonInstituteLightResponseWithId, isAdmin: boolean) => {
  editInstitute.value = institut;
  editAdminInstitute.value = isAdmin;
}

const openDeleteModal = (institut : PersonInstituteLightResponseWithId, isAdmin: boolean) => {
  isDeleteModalOpen.value = true;
  currentInstituteToDelete.value.instituteId = institut.id;
  currentInstituteToDelete.value.addRoleAdmin = isAdmin;
}

const closeDeleteConfirmModal = () => {
  adminApi.deleteLinkInstituteAtPerson({personId: props.currentMedicalPerson.id, linkInstitutePersonRequest: currentInstituteToDelete.value}).then(() => {
    toastSuccess(toast, {
      summary: t('common.toast.success.delete'),
      detail:  t('admin.medicalPerson.institute.delete.message.success')
    });
    getMedicalPersonIntituteData();
  }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
  });
  isDeleteModalOpen.value = false;

}

const confirmFormModal = () => {
  emits('modal-close');
}

const clearFilter = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
};

watch(
    () => props.isOpen,
   () => {
    if (props.currentMedicalPerson) {
      getMedicalPersonIntituteData();
    }
  }
)


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_es_modal_header, {
                header: _unref(t)('admin.medicalPerson.institute.title', {name: _ctx.currentMedicalPerson.name})
              }, null, 8, ["header"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(EsAddInstitutePersonForm, {
                    "medical-person-id": _ctx.currentMedicalPerson.id,
                    onRefresh: _cache[0] || (_cache[0] = ($event: any) => (getMedicalPersonIntituteData())),
                    "editing-institute": editInstitute.value,
                    editingIsAdmin: editAdminInstitute.value
                  }, null, 8, ["medical-person-id", "editing-institute", "editingIsAdmin"])
                ]),
                _createVNode(_unref(DataTable), {
                  filters: filters.value,
                  "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
                  dataKey: "id",
                  globalFilterFields: ['instituteLight.name'],
                  loading: loading.value,
                  value: medicalPersonInstitutesList.value,
                  stripedRows: "",
                  paginator: "",
                  rows: 5,
                  class: "w-full"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(IconField), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(InputIcon), null, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                                class: "img-grey"
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(InputText), {
                            modelValue: filters.value['global'].value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                            placeholder: _unref(t)('admin.medicalPerson.institute.search')
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createVNode(_unref(InputIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(EsButtonIcon, {
                                icon: "xmark",
                                folder: "shareIcons",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                                styles: "img-grey"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.medicalPerson.institute.table.empty')), 1)
                  ]),
                  loading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(Column), {
                      field: 'name',
                      header: _unref(t)('admin.medicalPerson.institute.table.name')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.instituteLight.name), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), {
                      field: 'role',
                      header: _unref(t)('admin.medicalPerson.institute.table.role')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.instituteLight.instituteRole), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), { field: 'isAdmin' }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('admin.medicalPerson.institute.table.isAdmin')), 1)
                      ]),
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(Tag), {
                            severity: slotProps.data.isAdmin ? 'success' : 'warn'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _unref(SharedService).getIcon(slotProps.data.isAdmin ? 'checkmark' : 'xmark', false, 'shareIcons')
                              }, null, 8, _hoisted_10)
                            ]),
                            _: 2
                          }, 1032, ["severity"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: 'active',
                      header: _unref(t)('admin.medicalPerson.institute.table.active')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_unref(Tag), {
                            severity: slotProps.data.instituteLight.active ? 'success' : 'warn',
                            value: slotProps.data.instituteLight.active ? _unref(t)('common.status.active') : _unref(t)('common.status.unactive')
                          }, null, 8, ["severity", "value"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), {
                      field: 'edit',
                      header: _unref(t)('admin.medicalPerson.institute.table.edit')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(EsButtonIcon, {
                          icon: "pencil_fill",
                          folder: "shareIcons",
                          class: "pad-l",
                          styles: "img-primary",
                          onClick: ($event: any) => (getCurrentInstituteToEdit(slotProps.data.instituteLight, slotProps.data.isAdmin))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_unref(Column), {
                      field: 'edit',
                      header: _unref(t)('admin.medicalPerson.institute.table.delete')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(EsButtonIcon, {
                          icon: "trash",
                          folder: "settings",
                          class: "pad-l",
                          styles: "img-primary",
                          onClick: ($event: any) => (openDeleteModal(slotProps.data.instituteLight, slotProps.data.isAdmin))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["header"])
                  ]),
                  _: 1
                }, 8, ["filters", "loading", "value"])
              ]),
              _createVNode(_component_es_modal_footer, {
                displayCancel: false,
                confirmLabel: 'action.close',
                confirmModalMethod: confirmFormModal
              })
            ], 512)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(EsConfirmDialog, {
      isOpen: isDeleteModalOpen.value,
      header: _unref(t)('admin.medicalPerson.institute.delete.modale.header'),
      message: _unref(t)('admin.medicalPerson.institute.delete.modale.message'),
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (isDeleteModalOpen.value = false)),
      "on-confirm": closeDeleteConfirmModal
    }, null, 8, ["isOpen", "header", "message"])
  ], 64))
}
}

})